export default "__VITE_ASSET__BbUTRaMX__"